import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { logout } from './authSlice';
import api from './config';

const initialState = {
  messages: [],
  loading: false,
  isSuccess: false,
  replying: false,
  errors: [],
};

export const fetchContactMessages = createAsyncThunk(
  'contactMessages/fetchContactMessages',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.get('/crm-module/contactus');
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch(logout());
      }
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const replyContactMessage = createAsyncThunk(
  'contactMessages/replyContactMessage',
  async ({ id, message }, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.post(`/crm-module/contactus/sendMail/${id}`, { message });
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch(logout());
      }
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

const contactMessagesSlice = createSlice({
  name: 'contactMessages',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchContactMessages.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchContactMessages.fulfilled, (state, { payload }) => {
        state.isSuccess = true;
        state.messages = Array.isArray(payload) ? payload : payload?.data || [];
        state.loading = false;
      })
      .addCase(fetchContactMessages.rejected, (state, { payload }) => {
        if (payload?.statusCode === 400) {
          state.errors = payload?.message;
        }
        state.isSuccess = false;
        state.loading = false;
      })
      .addCase(replyContactMessage.pending, (state) => {
        state.replying = true;
      })
      .addCase(replyContactMessage.fulfilled, (state, { payload }) => {
        // Le backend renvoie le message mis à jour (avec ses réponses) : on le remplace dans la liste.
        if (payload?._id) {
          state.messages = state.messages.map((m) => (m._id === payload._id ? payload : m));
        }
        state.replying = false;
      })
      .addCase(replyContactMessage.rejected, (state, { payload }) => {
        if (payload?.statusCode === 400) {
          state.errors = payload?.message;
        }
        state.replying = false;
      });
  }
});

export default contactMessagesSlice.reducer;
